import React from "react";
import { components, ValueContainerProps } from "react-select";

import { IActionSelectOption } from "../ActionSelect";

const { ValueContainer } = components;

interface IconValueContainerProps
  extends ValueContainerProps<IActionSelectOption, false> {
  icon?: JSX.Element;
  prefix?: string;
}

export const IconValueContainer: React.ComponentType<IconValueContainerProps> = ({
  children,
  icon,
  prefix,
  ...props
}) => {
  return (
    <ValueContainer {...props}>
      {icon}
      <span>{prefix && `${prefix} `}</span>
      {children}
    </ValueContainer>
  );
};
